import { defineMessages } from 'react-intl';
export const overCharacterLimitMessage = defineMessages({
    overCharacterLimit: {
        defaultMessage: 'Your query is {numCharacters, plural, one {# character} other {# characters}} over the limit. Shorten it to submit.',
        description: 'Visible validation message shown when the ask input query exceeds the character limit.',
        id: '381a6396c6',
    },
}).overCharacterLimit;
//# sourceMappingURL=inputLimitMessages.js.map